import { SubHeading } from '../../common/subHeading';
import KeyRatiosDesktop from './keyRatiosDesktop';

export const KeyRatio = ({ insights }) => {
  return (
    <div className="related-funds-block lil-mt-5">
      <SubHeading title="Key Risk & Return Ratios" />
      <div className="">
        <KeyRatiosDesktop insights={insights} />
      </div>
      {/* <div className="xl:lil-hidden md:lil-hidden lg:lil-hidden lil-rounded-xl lil-shadow-xl keyRatioMobile">
        <KeyRatioMobile insights={insights} />
      </div> */}
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/keyRatios/index.tsx